import { createTheme } from '@mui/material/styles';

// A custom theme for this app
const getTheme = (mode) => {
  return createTheme({
    palette: {
      mode,
      ...(mode === 'light'
        ? {
            // Light mode palette
            primary: {
              main: '#4F46E5',
            },
            secondary: {
              main: '#3B82F6',
            },
            background: {
              default: '#f9fafb',
              paper: '#FFFFFF',
            },
            text: {
              primary: '#1e293b',
              secondary: '#64748b',
            },
            error: {
              main: '#ef4444',
            },
            warning: {
              main: '#f59e0b',
            },
            info: {
              main: '#3b82f6',
            },
            success: {
              main: '#22c55e',
            },
            divider: '#e5e7eb',
          }
        : {
            // Dark mode palette with more vibrant colors
            primary: {
              main: '#818cf8', // Vibrant indigo
            },
            secondary: {
              main: '#60a5fa', // Vibrant blue
            },
            background: {
              default: '#0f172a', // Deep navy
              paper: '#1e293b', // Darker navy
            },
            text: {
              primary: '#f1f5f9', // Light gray
              secondary: '#94a3b8', // Medium gray
            },
            error: {
              main: '#f87171', // Vibrant red
            },
            warning: {
              main: '#fbbf24', // Vibrant amber
            },
            info: {
              main: '#60a5fa', // Vibrant blue
            },
            success: {
              main: '#4ade80', // Vibrant green
            },
            divider: 'rgba(71, 85, 105, 0.3)', // Semi-transparent slate
          }),
    },
    typography: {
      fontFamily: [
        'Montserrat',
        '-apple-system',
        'BlinkMacSystemFont',
        '"Segoe UI"',
        'Roboto',
        '"Helvetica Neue"',
        'Arial',
        'sans-serif',
        '"Apple Color Emoji"',
        '"Segoe UI Emoji"',
        '"Segoe UI Symbol"',
      ].join(','),
    },
    components: {
      ...(mode === 'dark' && {
        MuiPaper: {
          styleOverrides: {
            root: {
              backgroundImage: 'none',
            },
          },
        },
        MuiCard: {
          defaultProps: {
            elevation: 4,
          },
          styleOverrides: {
            root: {
              background: 'rgba(30, 41, 59, 0.8)',
              backdropFilter: 'blur(10px)',
              transition: 'all 0.3s ease',
            },
          },
        },
        MuiButton: {
          styleOverrides: {
            root: {
              transition: 'all 0.3s ease',
              '&:hover': {
                transform: 'translateY(-2px)',
                boxShadow: '0 6px 12px rgba(0, 0, 0, 0.2)',
              },
            },
          },
        },
        MuiIconButton: {
          styleOverrides: {
            root: {
              transition: 'all 0.2s ease',
              '&:hover': {
                transform: 'scale(1.1)',
              },
            },
          },
        },
        MuiTooltip: {
          styleOverrides: {
            tooltip: {
              backgroundColor: 'rgba(15, 23, 42, 0.9)',
              border: '1px solid rgba(71, 85, 105, 0.5)',
              backdropFilter: 'blur(4px)',
              fontSize: '0.75rem',
            },
          },
        },
      }),
    },
  });
};

export default getTheme; 